<template>
  <div id="modal-confirm" class="ui small modal">
    <div class="header">
      Please confirm...
    </div>
    <div class="content" v-html="payload.message" />
    <div class="actions">
      <button class="ui button" @click="confirm(false)">Cancel</button>
      <button class="ui positive button" @click="confirm(true)">Yes</button>
    </div>
  </div>
</template>

<script>
export default {
  props: ['payload'],

  methods: {
    confirm (result) {
      this.$emit('confirm', result)
      window.$('#modal-confirm').modal('hide')
    }
  }
}
</script>



// WEBPACK FOOTER //
// ModalConfirm.vue?718dafcc